import { HStack, Stack, Text, VStack } from '@chakra-ui/react'
import { OwnerSubmitType } from 'context/types'

import { CustomFileCheck } from 'components/CustomFileCheck'
import { FileControl } from 'components/InputCustom'

type Props = {
  values: OwnerSubmitType
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void
}

export const StepOne: React.FC<Props> = ({ values: { fileOne, fileTwo }, setFieldValue }) => {
  return (
    <VStack w={'full'} spacing={4} justifyContent={'flex-start'} alignItems={'flex-start'}>
      <Text variant={{ base: 'MD_SB', md: 'LG_SB' }}>1. Adjunta tu carnet por ambos lados</Text>
      <VStack w={'full'} spacing={0} >
        <HStack w={'full'} justifyContent={'flex-start'}>
          <Text variant={{ base: 'SM_SB', md: 'MD_SB' }}>Formatos permitidos:</Text>
          <Text variant={{ base: 'SM', md: 'MD' }}>JPG, JPEG, PNG, PDF </Text>
        </HStack>
        <HStack w={'full'}>
          <Text variant={{ base: 'SM_SB', md: 'MD_SB' }}>Tamaño máximo cada foto:</Text>
          <Text variant={{ base: 'SM', md: 'MD' }}>2 MB</Text>
        </HStack>
      </VStack>
      <Stack
        w='full'
        h='auto'
        alignItems='flex-start'
        justifyContent='space-evenly'
        direction={{ base: 'column', md: 'row' }}>
        {fileOne && <CustomFileCheck text={fileOne.name} onClick={() => setFieldValue('fileOne', null)} />}
        {fileTwo && <CustomFileCheck text={fileTwo.name} onClick={() => setFieldValue('fileTwo', null)} />}
      </Stack>
      <FileControl name={fileOne ? 'fileTwo' : 'fileOne'} buttonProps={{ disabled: !!fileOne && !!fileTwo }} />
    </VStack>
  )
}
